import { useState, useEffect, useCallback } from 'react';
import { transaccionService } from '../services/supabase';

export function useEconomia(usuarioId, campoId) {
  const [transacciones, setTransacciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar transacciones
  const loadTransacciones = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await transaccionService.getAll(usuarioId, campoId);
      setTransacciones(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando transacciones:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  // Auto-cargar
  useEffect(() => {
    loadTransacciones();
  }, [loadTransacciones]);

  // Crear transacción
  const createTransaccion = useCallback(async (transaccion) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await transaccionService.create(usuarioId, campoId, transaccion);
      setTransacciones(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  // Actualizar transacción
  const updateTransaccion = useCallback(async (transaccionId, updates) => {
    try {
      const updated = await transaccionService.update(transaccionId, updates);
      setTransacciones(prev => prev.map(t => t.id === transaccionId ? updated : t));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  // Eliminar transacción
  const deleteTransaccion = useCallback(async (transaccionId) => {
    try {
      await transaccionService.delete(transaccionId);
      setTransacciones(prev => prev.filter(t => t.id !== transaccionId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    transacciones,
    setTransacciones,
    loading,
    error,
    loadTransacciones,
    createTransaccion,
    updateTransaccion,
    deleteTransaccion,
  };
}
